<template>
  <div class="app-main-content" type="primary">
    <div
      class="grid-view"
    >
      <div v-show="action ==='list'" class="main-content">
        <search-item
          ref="searchItem"
          config-module="3300"
          :reset="true"
          :expand-adv="true"
          :show-simple="false"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>isAdvancedQuery=value"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              type="primary"
              @click="addHandler"
            >{{ this.$t('CargoMsg.Cargo_NewTo') }}
            </el-button>
            <el-button
              type="primary"
              @click="editHandler"
            >{{ this.$t('CargoMsg.Cargo_Edit') }}
            </el-button>
            <el-button
              type="danger"
              @click="deleteHandler"
            >{{ this.$t('CargoMsg.Cargo_OrderDelete') }}
            </el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="25000617"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="25000618"
            :total="filter.total"
            :page-count="pageCount"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
      <div v-show="['edit', 'add'].includes(action)" class="main-content rule-config-page">
        <div class="grid-wrapper" style="display: flex">
          <div style="width: 45%;height: 100%;">
            <el-form
              label-position="left"
              label-width="0px"
              style="height: 100%"
            >
              <div style="height: 100%;">
                <span>{{ $t('CargoMsg.Cargo_ScriptName') }}</span>
                <el-form-item :label="''">
                  <el-input v-model="form.scriptName" :filter-chars="false" clearable />
                </el-form-item>
                <span>{{ $t('CargoMsg.Cargo_RuleDescription') }}</span>
                <el-form-item :label="''" style="height: 100%" class="input-from">
                  <el-input v-model="form.scriptDescription" :placeholder="scriptDescriptionTip" class="input-border" :filter-chars="false" type="textarea" clearable />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div style="width: 10%; display: flex; justify-content: center;align-items: center">
            <el-button type="primary" @click="generateScript">{{ $t('CargoMsg.Cargo_GenerateScript') + ' >>' }}  </el-button>
          </div>
          <div style="width: 45%;height: 100%">
            <el-form
              label-position="left"
              label-width="0px"
              style="height: 100%"
            >
              <div style="height: 100%">
                <div style="padding-bottom: 50px" />
                <span>{{ $t('CargoMsg.Cargo_ScriptPreview') }}</span>
                <el-form-item :label="''" style="height: 100%" class="input-from">
                  <el-input v-model="form.scriptContent" :placeholder="scriptContentTip" class="input-border" :filter-chars="false" type="textarea" clearable />
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>

        <div style=" display: flex; align-items: center;justify-content: center;">
          <div style="margin-bottom: 20px; margin-top: 20px">
            <div style="display: inline-block">
              <el-button type="primary" no="1" style="margin-left: 5px;" @click="saveHandler"> {{ $t('CargoMsg.Cargo_Save') }} </el-button>
              <el-button type="primary" no="1" style="margin-left: 5px;" @click="cancelHandler()"> {{ $t('CargoMsg.Cargo_Cancel') }} </el-button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import URL from '@/api/urlTranslator'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { advancedQuery, deleteRuleConfigFunc, generateScriptFunc, saveFunc } from '@/api/ruleConfig/ruleConfigAi'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import $store from '@/store'

export default {
  name: 'RuleConfig',
  components: {
    searchItem
  },
  data() {
    return {
      URL,
      isAdvancedQuery: true, // 是否为高级查询
      pageCount: 0,
      SystemConstants: SystemConstants,
      filter: {
        conditions: [],
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      action: 'list',
      form: {
        uuid: '',
        version: 1,
        scriptName: '',
        scriptDescription: '',
        scriptContent: ''
      },
      filterJson: {},
      selectData: null,
      fullscreenLoading: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中
        onRowClicked: (event) => {
          this.selectData = event.data
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectData = node.data
              }
            })
          }
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '',
          width: 55,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ScriptName'),
          colId: 'scriptName',
          field: 'scriptName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ScriptDescription'),
          colId: 'scriptDescription',
          field: 'scriptDescription',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'),
          field: 'modifiedBy',
          width: 200,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateModified'),
          colId: 'dateModified',
          field: 'dateModified',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      scriptDescriptionTip: '示例：\n' +
        '作为业务员提成规则，以实际票数为统计\n' +
        '1、业务类型是 海运出口的费用，每票提成5元；\n' +
        '2、业务类型是 海运进口的费用，每票提成3元；\n' +
        '3、业务类型是 空运出口的费用，每票提成6元。\n' +
        '\n' +
        '注： 汇总后是计提金额。',
      scriptContentTip: 'SELECT \n' +
        '    fd.tenant_id,\n' +
        '    du.USER_ID AS user_id,\n' +
        '    du.CHINESE_NAME AS user_name,\n' +
        '    COUNT(DISTINCT fd.legacy_id) AS jobCount,\n' +
        '    GROUP_CONCAT(DISTINCT fd.legacy_id) AS jobs,\n' +
        '    GREATEST(0, \n' +
        '        COUNT(CASE WHEN fd.business_mode_type_name = \'海运出口\' THEN 1 END) * 5 +\n' +
        '        COUNT(CASE WHEN fd.business_mode_type_name = \'海运进口\' THEN 1 END) * 3 +\n' +
        '        COUNT(CASE WHEN fd.business_mode_type_name = \'空运出口\' THEN 1 END) * 6\n' +
        '    ) AS commissionAmount,\n' +
        '    0 AS riskReserveAmount\n' +
        'FROM \n' +
        '    fact_data fd\n' +
        '    LEFT JOIN fact_data_business_expansion fdb ON fd.legacy_id = fdb.job_uuid AND (fdb.sales_provision = 0 OR fdb.sales_provision IS NULL)\n' +
        '    LEFT JOIN DMN_USER du ON fd.sales_id = du.ID AND fd.tenant_id = du.TENANT_ID\n' +
        'WHERE \n' +
        '    1 = 1 \n' +
        '    AND fd.tenant_id = 9695 \n' +
        '    AND fd.business_date >= DATE_SUB(CURRENT_DATE(), INTERVAL 3 MONTH)\n' +
        'GROUP BY \n' +
        '    du.USER_ID, \n' +
        '    du.CHINESE_NAME, \n' +
        '    fd.tenant_id'
    }
  },
  computed: {},
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    }
  },
  beforeMount() {
    setTimeout(() => {
      this.toQuery()
    }, 0)
  },
  methods: {
    init() {},
    toQuery() {
      this.toAdvancedQuery()
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.pageCount = res.data.pages
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = data
        // 高级查询条件组装
        this.filter.conditions = [... data]
        this.filter.pageNum = 1
      }
      this.filterJson.conditions = this.filter.conditions
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading4Cxt()
      advancedQuery(this.filterJson).then((res) =>
        this.handleQueryData(res)
      ).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 新增
    addHandler() {
      this.clear()
      this.action = 'add'
    },
    // 编辑
    editHandler() {
      if (!this.selectData || !this.selectData.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      this.action = 'edit'
      this.clear()
      this.form = { ...this.selectData }
    },
    // 删除
    deleteHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('Message.ConfirmDeleteN', [rows.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading4Cxt()
        const data = {
          keys: Array.from(rows, p => p.uuid)
        }
        deleteRuleConfigFunc(data).then(res => {
          this.toQuery()
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        }).finally(() => {
          this.fullscreenLoading.close()
        })
      }).catch(() => { })
    },
    saveHandler() {
      this.fullscreenLoading = getLoading4Cxt()
      this.form.branchId = $store.getters.currentOfficeId
      saveFunc(this.form).then(res => {
        this.cancelHandler()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    clear() {
      this.form.uuid = ''
      this.form.version = 1
      this.form.scriptName = ''
      this.form.scriptDescription = ''
      this.form.scriptContent = ''
    },
    // 生成脚本
    generateScript() {
      if (!this.form.scriptDescription) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_PromptWords'))
        return
      }
      this.fullscreenLoading = getLoading4Cxt()
      generateScriptFunc({ anyStr: this.form.scriptDescription }).then(res => {
        this.form.scriptContent = res.data
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    cancelHandler() {
      this.clear()
      this.action = 'list'
      this.toQuery()
    }
  }
}
</script>
<style lang="scss">
.rule-config-page {
  padding-top: 20px;
  padding-left: 10px;
  background-color: white;

  .input-from {
    .el-form-item__content {
      width: 100%;
      height: 90%;
    }
  }

  .input-border {
    height: 100%;
    .el-textarea__inner{
      width: 100%;
      height: 100%;
    }
  }
}

</style>
